import { createSlice } from "@reduxjs/toolkit";

// urutan card dashboard, key: "<username>:<storageKey>" -> array id card
const initialState = {
  orders: {},
};

export const dashboardLayoutSlice = createSlice({
  name: "dashboardLayout",
  initialState,
  reducers: {
    setDashboardOrder: (state, action) => {
      const { key, order } = action.payload;
      if (order) state.orders[key] = order;
      else delete state.orders[key];
    },
  },
});

export const { setDashboardOrder } = dashboardLayoutSlice.actions;
export default dashboardLayoutSlice.reducer;
